import { Bull } from 'components/Bull';
import { ArticleTypeMap, LangMap } from 'config';
import { timeout } from 'helpers';
import React from 'react';
import { connect } from 'react-redux';
import { updateAudioPlaybackArticleIndex } from 'store/temp/actions';
import { ApplicationState, Article, AudioCurrentState } from 'types';
import { AudioPlaybackInstance } from './AudioPlayback';
import { PlayListRow } from './PlayListRow';

interface TileProps {
	record?: Article;
	index?: number;
	currentIndex?: number;
	currentState?: AudioCurrentState;
	listLength: number;
	moveToIndex: (currentIndex: number) => void;
}

class PlayListTile extends React.Component<TileProps, any> {
	shouldComponentUpdate(nextProps: TileProps) {
		return this.props.record !== nextProps.record || this.props.index !== nextProps.index || this.props.currentIndex !== nextProps.currentIndex;
	}

	render() {
		let { record, index, moveToIndex, currentIndex, listLength } = this.props;

		return (
			<PlayListRow
				loading={!record}
				selected={index === currentIndex}
				last={index === listLength - 1}
				onClick={async () => {
					moveToIndex(index!);

					await timeout(100);
					AudioPlaybackInstance().playAudio();
				}}
				title={record && (record.title.hi || record.title.en)}
				titleClass={record?.title.hi ? 'locale-hi' : ''}
				subheader={
					record && (
						<>
							{ArticleTypeMap[record.articleType]}
							<Bull />
							{LangMap[record.lang]}
						</>
					)
				}
				length={record?.mediaLength}
			/>
		);
	}
}

function mapStateToProps({ tempState }: ApplicationState) {
	let { audioPlaybackDetails, audioPlaybackState } = tempState;

	return {
		currentState: audioPlaybackState.currentState,
		currentIndex: audioPlaybackDetails?.currentIndex,
		listLength: audioPlaybackDetails?.articleList?.length || 0,
	};
}

function mapDispatchToProps(dispatch: any) {
	return {
		moveToIndex: (currentIndex: number) => {
			dispatch(updateAudioPlaybackArticleIndex(currentIndex));
		},
	};
}

let connectedEle = connect(mapStateToProps, mapDispatchToProps)(PlayListTile);
export default connectedEle;
